import { render, staticRenderFns } from "./TagSheet.vue?vue&type=template&id=46151a43&scoped=true&"
import script from "./TagSheet.vue?vue&type=script&lang=ts&"
export * from "./TagSheet.vue?vue&type=script&lang=ts&"
import style0 from "./TagSheet.vue?vue&type=style&index=0&id=46151a43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46151a43",
  null
  
)

export default component.exports